<template>
  <div>
    <b-card class="">
      <b-modal
        header-bg-variant="primary"
        header-text-variant="white"
        id="shipModal"
        title="Reason for Rejection"
        hide-footer
        hide-header
        modal-content-classes="cust-modal-ht-wo cust-overflow-y-grey flex justify-center"
        class="overflow-y-hidden"
      >
        <div class="flex justify-between items-center pb-4">
          <p class="text-xl font-semibold">Shipment Details</p>
        </div>
        <div class="mb-4">
          <p class="input-title text-black">Carrier Name</p>
          <b-input
            v-model="shipmentCompany"
            placeholder="Enter carrier name"
            class="custipshadow"
            name="Description"
          ></b-input>
        </div>
        <div class="mb-4">
          <p class="input-title text-black">Shipment Number</p>
          <b-input
            v-model="shipmentNo"
            placeholder="Enter shipment number"
            class="custipshadow"
            name="Description"
          ></b-input>
        </div>
        <div class="flex justify-center">
          <b-button
            type="submit"
            variant="primary"
            @click="handleStatus(shippedStatus, shippedData)"
            >Save</b-button
          >
        </div>
      </b-modal>
      <div class="flex justify-between">
        <h2 class="text-2xl font-semibold">Order Management</h2>
      </div>
      <div class="flex justify-between items-center">
        <div class="flex gap-4 py-3">
          <div>
            <div>
              <label for="">Start Date</label>
            </div>
            <input
              id="custdatepicker"
              class="custdatepicker"
              v-model="startDate"
              type="date"
              placeholder="Pick a day"
            />
          </div>
          <div>
            <div>
              <label for="">End Date</label>
            </div>
            <input
              id="custdatepicker"
              class="custdatepicker"
              v-model="endDate"
              type="date"
              placeholder="Pick a day"
            />
          </div>
        </div>
        <div class="pt-12 flex gap-2">
          <button
            class="bg-primary py-2 text-white rounded-lg px-5"
            @click="filterDate"
          >
            Filter
          </button>
          <button
            class="bg-primary py-2 text-white rounded-lg px-5"
            @click="clearFilter"
          >
            Clear All
          </button>
        </div>
        <!-- <div class="pt-12">
        
        </div> -->
      </div>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="productOrder.result"
      >
        <!-- <el-table-column label="Sr no." prop="srno" min-width="80px" sortable>
          <template v-slot="{ row }">
            <b-media no-body class="align-items-center">
              <b-media-body>
                <span class="font-medium name mb-0 text-sm">{{
                  row.srno
                }}</span>
              </b-media-body>
            </b-media>
          </template>
        </el-table-column> -->
        <el-table-column
          label="Invoice ID"
          prop="pid"
          min-width="120px"
          v-slot="{ row }"
        >
          {{ row.invoiceId }}
        </el-table-column>
        <el-table-column
          label="Product Name"
          prop="pname"
          min-width="140px"
          v-slot="{ row }"
        >
          {{ row.product.name.slice(0, 50) }}...
        </el-table-column>
        <el-table-column
          label="Product Quantity"
          min-width="160px"
          prop="pquantity"
          v-slot="{ row }"
        >
          {{ row.product.quantity }}
        </el-table-column>
        <el-table-column
          label="Order Date"
          min-width="170px"
          prop="pquantity"
          v-slot="{ row }"
        >
          {{
            row.createdAt
              ? new Date(row.createdAt).toLocaleString("en-IN", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : ""
          }}
        </el-table-column>
        <el-table-column
          label="Name"
          min-width="160px"
          prop="name"
          v-slot="{ row }"
        >
          {{ row.deliveryDetails.fullName }}
        </el-table-column>
        <el-table-column
          label="Email"
          prop="email"
          min-width="180px"
          v-slot="{ row }"
        >
          {{ row.deliveryDetails.email }}
        </el-table-column>

        <el-table-column
          label="Contact No."
          prop="mobile"
          min-width="160px"
          v-slot="{ row }"
        >
          {{ row.deliveryDetails.phoneNumber }}
        </el-table-column>

        <el-table-column
          label="Shipping Address"
          prop="shippAdd"
          min-width="190px"
          v-slot="{ row }"
        >
          {{ row.deliveryDetails.address }}, {{ row.deliveryDetails.landMark }},
          {{ row.deliveryDetails.townCity }}
          ({{ row.deliveryDetails.pinCode }}),
          {{ row.deliveryDetails.state }}
        </el-table-column>

        <el-table-column
          label="Amount"
          prop="amount"
          min-width="150px"
          v-slot="{ row }"
        >
          {{ row.product.discountPrice }}
        </el-table-column>
        <el-table-column
          label="Status"
          prop="amount"
          min-width="150px"
          v-slot="{ row }"
        >
          {{
            row.product.status === "complete" ? "Delivered" : row.product.status
          }}
        </el-table-column>
        <el-table-column
          label="Courier Service"
          prop="amount"
          min-width="150px"
          v-slot="{ row }"
        >
          {{ row.product.shipmentCompany ? row.product.shipmentCompany : "-" }}
        </el-table-column>
        <el-table-column
          label="Tracking Id"
          prop="amount"
          min-width="150px"
          v-slot="{ row }"
        >
          {{
            row.product.shipmentNumber
              ? row.product.shipmentNumber
              : "Not Shipped Yet"
          }}
        </el-table-column>
        <el-table-column label="Action" min-width="150px" prop="status">
          <template v-slot="{ row }">
            <el-dropdown
              trigger="click"
              class="dropdown"
              @command="handleSelect(row, $event)"
            >
              <base-button
                type="primary"
                class="px-6 py-1 mx-1 flex items-center h-10 ml-4"
                >Status Update</base-button
              >
              <el-dropdown-menu>
                <!-- <el-dropdown-item>Pending</el-dropdown-item> -->
                <el-dropdown-item command="shipped">Shipped</el-dropdown-item>
                <el-dropdown-item command="complete"
                  >Completed</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <!-- <base-button
            type="primary"
            class="px-6 py-1 mx-1 flex items-center h-10 ml-4"
            @click="handleStatus('complete', row)"
            v-if="row.product.status === 'shipped'"
          >
            Completed
          </base-button>
          <base-button
            type="primary"
            class="px-6 py-1 mx-1 flex items-center h-10 ml-4"
            @click="handleShipped('shipped', row)"
            v-if="row.product.status === 'pending'"
          >
            Shipped
          </base-button> -->

          <!-- <base-button
            type="primary"
            class="px-6 py-1 mx-1 flex items-center h-10 ml-4"
            v-if="row.productDetails.status === 'Complete'"
            disabled
            @click="handleStatus('Complete', row)" 
          >
            Delivered
          </base-button> -->
        </el-table-column>
      </el-table>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          @change="handlePageChange"
          :per-page="perPage"
          :total="total_row"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import moment from "moment";
// import projects from "../../../layouts/components/projects";
import { mapState } from "vuex";
export default {
  name: "light-table",
  components: {
    moment,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      shippedData: {},
      shippedStatus: "",
      shipmentNo: "",
      shipmentCompany: "",
      currentPage: 1,
      total_row: 1,
      perPage: 5,
      startDate: "",
      endDate: "",
    };
  },
  methods: {
    handleSelect(row, event) {
      if (event === "complete") this.handleStatus(event, row);
      if (event === "shipped") this.handleShipped(event, row);
    },
    async init() {
      let loader = this.$loading();
      try {
        await this.$store.dispatch("affiliate/getVendorById", {
          userId: this.user._id,
        });
        let payload = {
          brandId: this.getVendor.vendor.brandId._id,
          limit: 5,
          offset: (this.currentPage - 1) * 5,
          startDate: this.startDate,
          endDate: this.endDate,
        };
        let data = await this.$store.dispatch(
          "affiliate/getBrandOrder",
          payload
        );
        this.total_row = this.productOrder.totalCount;
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    handleShipped(status, data) {
      this.shippedData = data;
      this.shippedStatus = status;
      this.$bvModal.show("shipModal");
    },
    async handleStatus(status, data) {
      this.$bvModal.hide("shipModal");
      let payload = {
        orderId: data._id,
        status: status,
      };
      if (status === "shipped") {
        Object.assign(payload, {
          shipmentNumber: this.shipmentNo,
          shipmentCompany: this.shipmentCompany,
        });
      }
      try {
        let loader = this.$loading();

        let data = await this.$store.dispatch("affiliate/orderStatus", payload);
        this.init();
        loader.close();
        if (data.code == 200) {
          this.$swal.fire({
            text: "Status Updated!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        this.shipmentNo = "";
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async handlePageChange(value) {
      this.currentPage = value;
      try {
        this.init();
      } catch (error) {}
    },
    async filterDate() {
      try {
        this.init();
      } catch (error) {}
    },
    async clearFilter() {
      try {
        this.startDate = "";
        this.endDate = "";
        this.init();
      } catch (error) {}
    },
  },
  computed: {
    ...mapState("auth", { user: "user" }),

    ...mapState("affiliate", {
      productOrder: "productOrder",
    }),
    ...mapState("affiliate", {
      brandData: "brandData",
      getVendor: "getVendor",
    }),
  },
  mounted() {
    this.init();
  },
};
</script>
<style>
#custdatepicker {
  padding: 6px !important;
  border: 1px solid gray !important;
  border-radius: 5px !important;
}
</style>
